import * as React from 'react'
import './CountDown.style'

interface TimeObjType {
    hh: string,
    mm: string,
    ss: string
}

export function CountDown(endTimeParams: string) {
    const endTime = endTimeParams
    const [time, setTime] = React.useState<TimeObjType>()
    let timer: any = 0

    React.useEffect(() => {
        beginCountdownInit(endTime)
        beginCountdown(endTime)
        return (() => {
            clearTimeout(timer)
        })
    }, [time])

    function beginCountdownInit(timeparams: string) {
        const getDuration = () => (parseFloat(timeparams) - parseInt((new Date().getTime() / 1000).toString(), 10))
        // const getMs = () => 9 -  parseInt((~~(new Date().getTime() / 1000).toString().split('.')[1] / 100).toString(), 10)
        const timeObj: TimeObjType = {
            hh: '00',
            mm: '00',
            ss: '00'
        }
        const duration = getDuration()

        let tmp = duration

        const ss = (tmp % 60).toFixed(0)

        if (ss) {
            timeObj.ss =  ss.length < 2 ? '0' + ss : ss.toString()
        }

        tmp = (tmp - Number(ss)) / 60
        const mm = (tmp % 60).toFixed(0)
        if (mm) {
            timeObj.mm = mm.length < 2 ? '0' + mm : mm.toString()
        }

        tmp = (tmp - Number(mm)) / 60
        const dd = (tmp - tmp % 24) / 24
        const hh = Number((tmp % 24 + dd * 24).toFixed(0)) < 0 ? 0 : Number((tmp % 24 + dd * 24).toFixed(0))
        if (hh) {
            timeObj.hh = hh.toString().length < 2 ? '0' + hh :  hh.toString()
        }
        setTime(timeObj)
    }

    function beginCountdown(timeParam: string) {
        const getDuration = () => (parseFloat(timeParam) - parseInt((new Date().getTime() / 1000).toString(), 10))
        // const getMs = () => 9 -  parseInt((~~(new Date().getTime() / 1000).toString().split('.')[1] / 100).toString(), 10)
        const timeObj: TimeObjType = {
            hh: '00',
            mm: '00',
            ss: '00'
        }
        timer = setTimeout(() => {
            const duration = getDuration()
            // const ms = getMs()
            if (duration < 0) {
                clearTimeout(timer)
            } else {
                // if (ms) { // 毫秒
                //     timeObj['ms'] =  ms + '0'
                // }

                let tmp = duration

                const ss = (tmp % 60).toFixed(0)

                if (ss) {
                    timeObj.ss =  ss.length < 2 ? '0' + ss : ss.toString()
                }

                tmp = (tmp - Number(ss)) / 60
                const mm = (tmp % 60).toFixed(0)
                if (mm) {
                    timeObj.mm = mm.length < 2 ? '0' + mm : mm.toString()
                }

                tmp = (tmp - Number(mm)) / 60
                const dd = (tmp - tmp % 24) / 24
                const hh = Number((tmp % 24 + dd * 24).toFixed(0)) < 0 ? 0 : Number((tmp % 24 + dd * 24).toFixed(0))
                if (hh) {
                   timeObj.hh = hh.toString().length < 2 ? '0' + hh :  hh.toString()
                }
                setTime(timeObj)
                beginCountdown(timeParam)
            }
        }, 1000)
    }

    if (time) {
        return time
    } else {
        return null
    }
}



// WEBPACK FOOTER //
// ./src/components/CountDown/CountDown.tsx